import {
  HOTEL_INFO_ROUTE_PATH,
  hotelInfoRouteParamNames,
  type IHotelInfoRouteParamName,
} from "@modules/hotel-info-path";

export type IPaymentProcessingParamName = "checkoutId" | IHotelInfoRouteParamName | "tripKey";
export const paymentProcessingParamNames: SameRecord<IPaymentProcessingParamName> = {
  checkoutId: "checkoutId",
  tripKey: "tripKey",
  ...hotelInfoRouteParamNames,
};

export type IPaymentProcessingSearchParamName = "payment_intent" | "payment_intent_client_secret";
export const paymentProcessingSearchParamNames: SameRecord<IPaymentProcessingSearchParamName> = {
  payment_intent: "payment_intent",
  payment_intent_client_secret: "payment_intent_client_secret",
};

export const PAYMENT_PROCESSING_PATH = `${HOTEL_INFO_ROUTE_PATH}/checkout/:${paymentProcessingParamNames.checkoutId}/trip/:${paymentProcessingParamNames.tripKey}/payment-processing`;
